import script from "./DesiredView.vue?vue&type=script&lang=ts&setup=true"
export * from "./DesiredView.vue?vue&type=script&lang=ts&setup=true"

import "./DesiredView.vue?vue&type=style&index=0&id=69a6e4a8&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/jobs/MASSMEDIAN_MYPAGE_VIEW_PROD/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-69a6e4a8"]])

export default __exports__